import { ConstructorInterfaceActionSelect } from '../../../../interface.type'
export default function SelectActionInterface({ action }: {
    action: ConstructorInterfaceActionSelect
}) {

    return <div className='ActionInterface'>
        Seleccionamos de {action.table}
    </div>

}